import { CaracterService } from './../core/caracter.service';
import { Validators } from "@angular/forms"
import { ActionInterface, ACTIONS_BASE } from "./actions.constants"
import { ColumnNames, FieldConfig } from "./form.constants"
import { ModalidadService } from "../core/modalidad.service";
import { NivelService } from '../core/nivel.service';
import { DEFAULT_PAGINATE_OPTIONS_LIST, PaginateOptions } from '../utils/paginate.utils';
import { TituloService } from '../core/titulo.service';

export const COMPETENCIAS_COLUMN_NAMES: ColumnNames[] = [
  { name: "materia.codigo", label: "Código" },
  { name: "materia.descripcion", label: "Materia" },
  { name: "caracter.descripcion", label: "Carácter" },
  { name: "modalidad.descripcion", label: "Modalidad" },
  { name: "anexo_resolucion", label: "Anexo Resolución" },
  { name: "observacion", label: "Observación" },
  { name: "fecha_alta", label: "Fecha Alta", pipe: "date" },
  { name: "deleted_at", label: "Fecha Baja", pipe: "date" },
  { name: "tituloConcurrente.descripcion", label: "Título Concurrente" , pipe: "nullToNo"},
  { name: "nivel.descripcion", label: "Nivel" },
]

export const COMPETENCIAS_FIELDS_CONFIG: FieldConfig = {
  nivel_id: {
    label: 'Nivel',
    type: 'select',
    position: 2,
    serviceForSelect: NivelService,
    validations: [Validators.required]
  },
  caracter_id: {
    label: 'Carácter',
    type: 'select',
    position: 3,
    options: [{ value: 0, label: "" }],
    serviceForSelect: CaracterService,
    validations: [Validators.required]
  },
  modalidad_id: {
    label: 'Modalidad',
    type: 'select',
    position: 4,
    serviceForSelect: ModalidadService,
    validations: [Validators.required]
  },
  anexo_resolucion: {
    label: 'Anexo Resolución',
    type: 'text',
    position: 5,
  },
  observacion: {
    label: 'Observacion',
    type: 'textarea',
    position: 6,
  },
  fecha_alta: {
    label: 'Fecha Alta',
    type: 'date',
    position: 1,
    validations: [Validators.required]
  }
}
export const COMPETENCIAS_FIELDS_CONFIG_CREATE: FieldConfig = {
  caracter_id: {
    label: 'Carácter',
    type: 'select',
    position: 3,
    options: [{ value: 0, label: "" }],
    serviceForSelect: CaracterService,
    validations: [Validators.required]
  },
  modalidad_id: {
    label: 'Modalidad',
    type: 'select',
    position: 4,
    serviceForSelect: ModalidadService,
    validations: [Validators.required]
  },
  anexo_resolucion: {
    label: 'Anexo Resolución',
    type: 'text',
    position: 5,
  },
  observacion: {
    label: 'Observacion',
    type: 'textarea',
    position: 6,
  },
  fecha_alta: {
    label: 'Fecha Alta',
    type: 'date',
    position: 1,
    validations: [Validators.required]
  }
}
export const COMPETENCIAS_FIELDS_SUPERIOR_CONFIG_CREATE: FieldConfig = {
  ...COMPETENCIAS_FIELDS_CONFIG_CREATE,
  titulo_concurrente: {
    label: 'Título Concurrente',
    type: 'select',
    position: 0,
    serviceForSelect: TituloService,
  }
}
export const COMPETENCIAS_ACTIONS: { [name: string]: ActionInterface } =
{
  delete: ACTIONS_BASE["delete"],
  "competencia-edit": {
    icon:"edit",
    traslation:"Dar de baja",
    url:'materias',
    type:'modal',
    tittle:'Editar Competencia',
    templateName:'modalDelete',
    modalSize:'medium',
  },
  "competencia-view": {
    icon:"visibility",
    traslation:"Ver Detalle",
    url:'materias',
    type:'modal',
    tittle:'Detalle',
    templateName:'modalDelete',
    showActionsButtons:false,
     modalSize:'small',
  }
  // "Asignar competencia" : {
  //   icon:"assignment",
  //   traslation:"Asignar Competencia",
  //   url:'competencias',
  //   type:'link'
  // }
}

export const COMPETENCIAS_ACTIONS_DELETED: { [name: string]: ActionInterface } = {
  restore : {
    traslation:'Restaurar',
    icon:"restore_from_trash",
    type:'modal',
  },
  "competencia-view": {
    icon:"visibility",
    traslation:"Ver Detalle",
    url:'materias',
    type:'modal',
    tittle:'Detalle',
    templateName:'modalDelete',
    showActionsButtons:false
  },
};
export const COMPETENCIAS_PAGINATE_OPTIONS:PaginateOptions = {
  ...DEFAULT_PAGINATE_OPTIONS_LIST,
}

